export default "__VITE_ASSET__0f0d53ac__"